// Shared status palette for Attention severities — reserved colors, never
// reused for anything else, always paired with the text label (never color
// alone). One source of truth so the summary chips and the item cards can't
// drift out of sync with each other.
export const SEVERITY_COLOR = {
  CRITICAL: '#C62828',
  HIGH: '#E65100',
  MEDIUM: '#F9A825',
  LOW: '#757575',
  INFO: '#9E9E9E',
};

export const SEVERITY_ORDER = ['CRITICAL', 'HIGH', 'MEDIUM', 'LOW', 'INFO'];
